window.addEventListener('scroll', function() {
    var header = document.getElementById('header');
    if (window.scrollY > 200) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

$(document).ready(function(){
  $('.collapsibleC').click(function(){
    $(this).next('.contentC').slideToggle(); // Toggle visibility of the next content div
    $(this).toggleClass('activeC');
  });
});
